import { createSelector } from '@ngrx/store';
import { selectPaymentsAndStatementsState } from '../reducers';
import * as fromNotifyOutstanding from '../reducers/notify-outstanding.reducer';

export { NotifyOutstandingState } from '../reducers/notify-outstanding.reducer';

export const selectNotifyOutstandingState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromNotifyOutstanding.notifyOutstandingFeatureKey]
);

export const selectNotifyAllOutstandingSuccess = createSelector(
  selectNotifyOutstandingState,
  (state) => state?.success
);

export const selectNotifyAllOutstandingFailure = createSelector(
  selectNotifyOutstandingState,
  (state) => state?.failure
);

export const selectNotifyAllOutstandingLoading = createSelector(
  selectNotifyOutstandingState,
  (state) => state?.loading
);
